// insert axios-like api instance, adds middleware to handle userRole header
import store from '@/store';

export default api => {
  api.interceptors.request.use(config => {
    const currentOperatingCompanyId =
      store.getters['user/currentOperatingCompany']?.id;
    if (currentOperatingCompanyId)
      config.headers['x-Operating-Company-Id'] = currentOperatingCompanyId;
    return config;
  });
  return api;
};
